<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        评估列表
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column
            prop="building_name"
            label="评估对象"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tr_create_time"
            label="评估时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="user_name"
            align="center"
            label="评估人"
          ></el-table-column>
          <el-table-column prop="tr_status" align="center" label="评估状态">
            <template slot-scope="scope">
              {{ $map.pgstatus[scope.row.tr_status] }}
            </template>
          </el-table-column>
          <el-table-column prop="cname" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="down(scope.row.tr_id)"
                v-if="scope.row.tr_status"
                >下载</el-button
              >
              <el-button size="mini" type="warning" v-else>未完成</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="10"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      ></fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyList, switchCompany } from "../../api/company";
export default {
  data() {
    return {
      list: [],
      params: { page: 1, status: "", start_at: "", end_at: "" },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("pinggusearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    getList() {
      // getCompanyList(this.params)
      //   .then((res) => {
      //     // console.log(res);
      //     this.total = res.count;
      //     this.list = res.list;
      //   })
      //   .catch((err) => {});

      this.$post("/phpcontro/list", this.params).then((res) => {
        log(res.data.data);
        this.total = res.data.data.count;
        this.list = res.data.data.list;
      });
    },
    down(tr_id) {
      this.$post("/phpcontro/download", { tr_id }).then((res) => {
        let url = res.data.data;
        window.location.href = url;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
